import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentElement, GridCell } from '../../models/sections-model';

@Component({
  selector: 'kw-product-link-renderer',
  templateUrl: './product-link-renderer.component.html',
  styleUrls: ['./product-link-renderer.component.scss']
})
export class ProductLinkRendererComponent implements OnInit {
  @Input() gridCell:GridCell;
  @Input() edit:boolean;
  contentElements:ContentElement[];

  @Output() createGridCellContent = new EventEmitter<GridCell>();
  
  constructor() { }

  ngOnInit(): void {
  }

  createContent(e){
    this.createGridCellContent.emit(e);
  }

}
